
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import EventBus from '../../eventBus'
  import { required } from 'vuelidate/lib/validators'
  import { Validations } from 'vuelidate-property-decorators'
  
  @Component
  export default class ManageRigTerrain extends Vue {
      @Validations()
      validations = {
          rigTerrain: {
              propertyName: { required },
          }
      }
      activeScreen: string = 'main'
      loadingMessage: string = 'Please wait while we create new rig terrain'
      loadingTitle: string = 'Saving...'
      additionalSuccessMessage: string = ''
      successMessage: string = 'New Rig Terrain Created Successfully'
      links: Array<object> = [
          {
              text: 'Chart Settings',
              to: '/chart-settings'
          },
          {
              text: 'Manage Rig Terrain',
              active: true
          }
      ]
      error: any = {
          generalMessage: '',
          errors: []
      }
      rigTerrain: any = {
          propertyName: '',
          backgroundColor: '',
          textColor: '',
      }
      activeItem: any = null
      formErrors: string[] = []
  
  
      // METHODS
      checkErrors() {
          this.formErrors = []
  
          if(this.rigTerrain.propertyName.length < 1) {
              this.formErrors.push('Rig Terrain is Required')
          }
      }
      
      newActivity(){
          this.rigTerrain.propertyName = '';
          this.$v.$reset()
      }
  
      persistData(){
          this.activeScreen = 'loading';
          EventBus.$emit('activeScreen', this.activeScreen)        
          if(this.activeItem == null)
              this.saveNew();
          else
              this.update();
      }
  
      update(){
          this.activeScreen = 'loading'
          EventBus.$emit('activeScreen', this.activeScreen)
          this.loadingMessage = 'Please wait while we update this rig terrain'
          this.loadingTitle = 'Saving...'
          var payload = this.createPayload()
          this.$store.dispatch('settingsModule/updateColorSetting', payload)
          .then((res: any) => 
              {
                  this.activeScreen = 'successNoGotIt'
                  EventBus.$emit('activeScreen', this.activeScreen)
                  this.additionalSuccessMessage = ''
                  this.successMessage = 'Rig Terrain Updated Successfully'
              }
          ).catch((err: any) => {
              this.activeScreen = 'error'
              EventBus.$emit('activeScreen', this.activeScreen)
              this.error.generalMessage = err.message
          })
      }
   
      createPayload() {
          return {
              settingType: 'Terrain',
              propertyName: this.rigTerrain.propertyName,
              id: this.activeItem ? this.activeItem.id : 0,
              backgroundColor:  typeof(this.rigTerrain.backgroundColor)=='string'?this.rigTerrain.backgroundColor:this.rigTerrain.backgroundColor.hex,
              textColor:  typeof(this.rigTerrain.textColor)=='string'?this.rigTerrain.textColor:this.rigTerrain.textColor.hex,
          }
      }
  
      saveNew(){
          var payload = this.createPayload()
          this.$store.dispatch('settingsModule/mutateColorSetting', [payload])
          .then((res: any) =>
              {
                  this.activeScreen = 'successRemain'
                  EventBus.$emit('activeScreen', this.activeScreen)
                  this.additionalSuccessMessage = 'You can now use the newly rig terrain'
                  this.successMessage = 'Successfully Created '+ payload.propertyName
                  this.newActivity()
              }
          ).catch((err: any) => {
              this.activeScreen = 'error'
              EventBus.$emit('activeScreen', this.activeScreen)
              this.error.generalMessage = err.message
          })
      }
  
  
  
      // VUEX METHODS
  
      // COMPUTED PROPERTIES
      get getRigSettings () {
        return this.$store.getters['settingsModule/getSettingsRig']
    }
    get fetchColorSettings() {
        return this.$store.dispatch('settingsModule/getColorSettings')
    }
      
      get isButtonDisabled(): boolean {
          if (this.formErrors.length > 0) {
              return true
          } else {
              return false
          }
      }
  
      // CREATED
      created() {
        this.fetchColorSettings.then(() => {
            if(this.$route.query.id){
                this.activeItem = this.getRigSettings.find((i: any) => i.id == this.$route.query.id)

                this.rigTerrain.propertyName = this.activeItem.propertyName,
                this.rigTerrain.backgroundColor = this.activeItem.backgroundColor;
                this.rigTerrain.textColor = this.activeItem.textColor;
          }else{
              this.checkErrors()
          }
        });
      }
  }
  
  